import React, { useEffect } from 'react';

const ESC_KEY_CODE = 27;

type BackdropProps = {
  onClose: () => void;
  backDropClass: string;
};

const Backdrop = React.forwardRef<HTMLButtonElement, BackdropProps>(({ onClose, backDropClass }, ref) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.keyCode === ESC_KEY_CODE) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown, false);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [onClose]);

  return (
    <button ref={ref} aria-label="Close area" className={backDropClass} onClick={onClose} type="button" tabIndex={-1}>
      &nbsp;
    </button>
  );
});

Backdrop.displayName = 'Backdrop';

export default Backdrop;
